<template>
    <b-button v-on="listeners" v-bind="attrs" class="align-baseline btn-circle-minus" variant="primary">
        <font-awesome-icon :icon="['fas', 'minus']"></font-awesome-icon>
    </b-button>
</template>

<script>
    export default {
        components: {},
        data() {
            return {
                busy: false,
            };
        },
        computed: {
            attrs() {
                const { state, ...attrs } = this.$attrs;
                return attrs;
            },
            listeners() {
                const { input, ...listeners } = this.$listeners;
                return listeners;
            },
        },
    };
</script>
